























import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import Modal from '@components/Modal'

settings =
  vue:
    components: {
      Modal,
    }

    data: ->
      consoleModal:
        show: false

    computed:
      serverContext: -> (process?.env?.VUE_APP_SERVER_CONTEXT || 'live').toUpperCase()

    methods:
      hiDevConsole: ->
        @consoleModal.show = true

      hiSetup: ->
        await RecessAPI.get 'tests/setup'
        @close()

      hiTeardown: ->
        await RecessAPI.get 'tests/teardown'
        @close()

      close: ->
        @consoleModal.show = false

export default VueOptions.vue settings
